





















import { Component, Vue } from "vue-property-decorator";
import { Countys } from "@/common/baseConfig";
import { routes } from "@/router";
import { time, seeTime } from "@/common/dataCollect";
@Component
export default class App extends Vue {
  created() {
    this.createChangeFontSize();
    // setTimeout(() => {
    //   (window as any)["changeFontSize"](1)
    // }, 1000)
    this.$store.dispatch("getAppInfo");
    // 浏览时长
    let st = time();
    console.log(st);
    document.addEventListener("visibilitychange", e => {
      if (document.hidden) {
        let t: any = time();
        let times = (Number(t) - Number(st)) / 1000;
        seeTime(times);
      }
    });
  }
  get keepAlive() {
    return this.$route.meta.keepAlive;
  }
  // app 修改字体全局方法
  // 1小字体，2：中字体(默认字体),3大字体   不传为默认字体
  // 重写changeFontSize
  createChangeFontSize() {
    (window as any)["changeFontSize"] = (fontSize: string | number) => {
      let appEle: HTMLElement | null = document.getElementById("app");
      if (appEle) {
        if (fontSize == 1) {
          appEle.classList.remove("font_size_big");
          appEle.classList.add("font_size_small");
        } else if (fontSize == 3) {
          appEle.classList.remove("font_size_small");
          appEle.classList.add("font_size_big");
        } else {
          appEle.classList.remove("font_size_small", "font_size_big");
        }
      }
    };
  }
}
